export enum UserStatus {
	InProgress = 'in-progress',
	Pending = 'pending',
	Approved = 'approved',
	Denied = 'denied',
	Deleted = 'deleted',
	CreatedByAdmin = 'created-by-admin',
}